import React, { useRef } from 'react'
import { Box, IconButton, useTheme, CircularProgress } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
// NOTE: import the hook as a **named** export if you exported it that way
import useUploadTaskImages from 'api/aws/tasks/useUploadTaskImages'
import { Task } from 'types'

interface TaskImageUploaderProps {
  task: Task
}

const TaskImageUploader: React.FC<TaskImageUploaderProps> = ({ task }) => {
  const theme = useTheme()
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const { mutate: uploadImages, isPending } = useUploadTaskImages()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || [])
    if (!files.length) return

    uploadImages(
      { task, files },
      {
        onSuccess: () => {
          // nothing else required; hook already swaps temps -> final & syncs caches
          // console.log('Successfully uploaded images')
        },
        onError: err => {
          console.error('Error uploading images', err)
        },
        onSettled: () => {
          // allow re-selecting the same files next time
          if (fileInputRef.current) fileInputRef.current.value = ''
        },
      }
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
      <IconButton component="label" disabled={isPending} sx={{ opacity: isPending ? 0.6 : 1 }}>
        {isPending ? <CircularProgress size={24} /> : <AddIcon sx={{ height: 35, width: 35 }} />}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,application/pdf" // include pdf if you support it
          multiple
          hidden
          onChange={handleFileChange}
        />
      </IconButton>
    </Box>
  )
}

export default TaskImageUploader

// // @ts-nocheck
// import React from 'react'
// import { Button, Box, Typography, IconButton } from '@mui/material'
// import useUploadTaskImages from '../../api/aws/tasks/useUploadTaskImages'
// import AddIcon from '@mui/icons-material/Add'
// import { useQueryClient } from '@tanstack/react-query'
// import { Task } from '../../types'

// interface TaskImageUploaderProps {
//   task: Task
// }

// const TaskImageUploader: React.FC<TaskImageUploaderProps> = ({ task }) => {
//   const queryClient = useQueryClient()
//   const { mutate: uploadImages } = useUploadTaskImages()

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files && e.target.files.length > 0) {
//       const formData = new FormData()
//       // Append each file with the same key, e.g. 'files'
//       Array.from(e.target.files).forEach(file => {
//         formData.append('files', file)
//       })
//       // Append additional required fields so the backend can update the item.
//       formData.append('tableName', 'TASKS_TABLE')
//       formData.append('PK', task.PK)
//       formData.append('SK', task.SK)
//       formData.append('fieldName', 'imageUrls')
//       console.log('FORM DATA', formData)
//       uploadImages(
//         { taskId: task.task_uuid, PK: task.PK, SK: task.SK, formData },
//         {
//           onSuccess: data => {
//             console.log('Successfully added file')
//             queryClient.invalidateQueries({ queryKey: ['task', task?.PK, task?.SK] })
//           },
//           onError: error => {
//             console.error('Error adding file', error)
//           },
//         }
//       )
//     }
//   }

//   return (
//     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
//       <IconButton variant="outlined" component="label">
//         <AddIcon sx={{ height: '35px', width: '35px' }} />
//         <input type="file" accept="image/*" multiple hidden onChange={handleFileChange} />
//       </IconButton>
//     </Box>
//   )
// }

// export default TaskImageUploader
